import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { ProjectAttributesService } from 'src/app/services/project-attributes.service';
import { AccessLevels } from 'src/app/models/access_levels';
import { EmployeeService } from 'src/app/services/employee.service';
import * as moment from 'moment';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.scss']
})
export class AddEmployeeComponent implements OnInit {

  roles = [{ access_level: 2, role: 'Station Manager', name: 'Station Manager' },
  { access_level: 3, role: 'Concierge', name: 'Concierge' },
  { access_level: 3, role: 'Sr. Concierge', name: 'Sr. Concierge' }]
  sources = [{label: 'Outsource', value: 'outsource'}, {label: 'AGI', value: 'AGI'}];
  jobTypes = ['Full Time', 'Part Time']
  status = ['Active', 'Inactive']
  traineeTypes = ['Yes', 'No']
  employee_form: FormGroup;

  selectedStatus: any;
  selectedJobName: any;
  selectedJobType: any;
  selectedLanguageids = [];
  selectedRole: any;
  selectedSource: any;
  selectedStations = [];
  selectedState: any;
  selectedCountry: any;

  allStations: any
  allLanguages: any
  allJobNames: any
  allCountries: any
  allStates: any

  isEditMode = false;
  formTitle = '';
  submitted = false
  maxDate = new Date();
  minDate = new Date(1900, 1, 1);

  hide = false;

  selectedTraineeType: any;
  employeeData;

 // PHONE_REGEXP = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

 

  public constructor(
    private formBuilder: FormBuilder,
    private notifier: NotifierService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService,
    private employeeService: EmployeeService,
    private stationService: StationService,
    private authenticationService: AuthenticationService,
    private projectAttrService: ProjectAttributesService) {
  }

  ngOnInit() {
    this.getStations();
    this.getProjectAttributes();
    this.getAllLanguages();
    if (this.route.snapshot.paramMap.get('id') != null) {
      this.formTitle = "Update Team Member";
      this.isEditMode = true;
      this.getEmployeeById(this.route.snapshot.paramMap.get('id'));
    } else {
      this.formTitle = "Add Team Member"
    }
    this.initAddEmployeeForm();
  }

  initAddEmployeeForm() {
    this.employee_form = new FormGroup({
      role: new FormControl('', Validators.required),
      source: new FormControl(''),
      empid: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(15)])),
      fname: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.maxLength(20), Validators.minLength(3)
      lname: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.maxLength(20), Validators.minLength(3)
      // prefferName: new FormControl(''),
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      password: new FormControl('WelcomeATS', Validators.compose([Validators.required, Validators.minLength(6)])),
      dob: new FormControl(''),
      status: new FormControl(''),
      hiredate: new FormControl('', Validators.compose([Validators.required])),
      // jobcode: new FormControl('', Validators.compose([Validators.required])),
      // jobname: new FormControl('', Validators.compose([Validators.required])),
      stations: new FormControl('', Validators.compose([Validators.required])),
      // address: new FormControl('', Validators.compose([Validators.required])),
      mobileNumber: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[0-9\-\+]*$')])),  // , Validators.minLength(10), Validators.maxLength(20)
      dailycap: new FormControl('', Validators.compose([Validators.required])),
      weeklycap: new FormControl('', Validators.compose([Validators.required])),
      hourlyrate: new FormControl('', Validators.compose([Validators.required])),
      jobtype: new FormControl('', Validators.compose([Validators.required])),
      languages: new FormControl('', Validators.compose([Validators.required])),
      address1: new FormControl(''),
      //traineeType: new FormControl('', Validators.compose([Validators.required])),
      address2: new FormControl(''),
      cityname: new FormControl(''),
      state: new FormControl(''),
      zipcode: new FormControl('', Validators.compose([Validators.pattern('[0-9A-Za-z ]*')])), // Validators.maxLength(5), 
      country: new FormControl(''),
    });
  }


  initUpdateEmployeeForm() {
    this.employee_form = this.formBuilder.group({
      empid: new FormControl(this.employeeData.emp_id, Validators.compose([Validators.required, Validators.maxLength(15)])),
      fname: new FormControl(this.employeeData.firstname, Validators.compose([Validators.required, Validators.minLength(3), Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.maxLength(20)
      lname: new FormControl(this.employeeData.lastname, Validators.compose([Validators.required, Validators.minLength(3), Validators.pattern('^[A-Za-z-()]+$')])), // , Validators.maxLength(20)
      // prefferName: new FormControl(this.employeeData.preferred_name, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(20), Validators.pattern('^[a-zA-Z \-\']+')])),
      email: new FormControl(this.employeeData.email, Validators.compose([Validators.required, Validators.email])),
      password: new FormControl(this.employeeData.password, Validators.compose([Validators.required, Validators.minLength(6)])),
      dob: new FormControl(new Date(moment.utc(this.employeeData.dob).format('MM/DD'))),
      hiredate: new FormControl(new Date(moment.utc(this.employeeData.hire_Date).format('MM/DD/YYYY')), Validators.compose([Validators.required])),
      // jobcode: new FormControl(this.selectedJobCode, Validators.required),
      jobtype: new FormControl(this.selectedJobType, Validators.required),
      // jobname: new FormControl(this.employeeData.job_name, Validators.required),
   //   traineeType: new FormControl(this.selectedTraineeType, Validators.required),
      stations: new FormControl(this.selectedStations, Validators.compose([Validators.required])),
      status: new FormControl(this.selectedStatus, Validators.required),
      terminateddate: new FormControl(new Date(moment.utc(this.employeeData.terminated_date).format('MM/DD/YYYY')), Validators.required),
      // ^((\\+91-?)|0)?[0-9]{10}$
      mobileNumber: new FormControl(this.employeeData.mobileno, Validators.compose([Validators.required , Validators.pattern('^[0-9\-\+]*$')])), // Validators.pattern(this.PHONE_REGEXP), Validators.maxLength(20)
      dailycap: new FormControl(this.employeeData.daily_cap, Validators.required),
      weeklycap: new FormControl(this.employeeData.weekly_cap, Validators.required),
      hourlyrate: new FormControl(this.employeeData.hourly_rate, Validators.required),
      languages: new FormControl(this.selectedLanguageids, Validators.required),
      role: new FormControl(this.selectedRole, Validators.required),
      source: new FormControl(this.selectedSource),
      address1: new FormControl(this.employeeData.address1),
      address2: new FormControl(this.employeeData.address2),
      cityname: new FormControl(this.employeeData.city),
      state: new FormControl(''),
      zipcode: new FormControl(this.employeeData.zipcode, Validators.compose([Validators.pattern('[0-9A-Za-z ]*')])),
      country: new FormControl(''),
    });
    this.setCapValidators(this.selectedRole);
  }

  setCapValidators(role) {
    if (role.access_level == AccessLevels.agent) {
      this.employee_form.get('dailycap').setValidators([Validators.required]);
      this.employee_form.get('weeklycap').setValidators([Validators.required]);
      this.employee_form.get('hourlyrate').setValidators([Validators.required]);

      this.employee_form.get('dailycap').updateValueAndValidity();
      this.employee_form.get('weeklycap').updateValueAndValidity();
      this.employee_form.get('hourlyrate').updateValueAndValidity();
    } else {
      this.employee_form.get('dailycap').setValidators(null);
      this.employee_form.get('weeklycap').setValidators(null);
      this.employee_form.get('hourlyrate').setValidators(null);

      this.employee_form.get('dailycap').updateValueAndValidity();
      this.employee_form.get('weeklycap').updateValueAndValidity();
      this.employee_form.get('hourlyrate').updateValueAndValidity();
    }
  }

  get employee_form_controls() { return this.employee_form.controls; }

  onAddEmployee(values) {
    this.submitted = true
    this.validateEmployee()
    if (this.selectedState == null || this.selectedState == 'undefined') {
      this.selectedState = ''
    }
    if (this.selectedCountry == null || this.selectedCountry == 'undefined') {
      this.selectedCountry = ''
    }
    this.employee_form.markAllAsTouched();
    if (this.employee_form.invalid) {
      return;
    }

    // if (values.address1 != '' && (values.cityname == '' || values.zipcode == '' || this.selectedState == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Cityname, State, Zipcode, Country')
    //   return;
    // }
    // if (values.cityname != '' && (values.address1 == '' || values.zipcode == '' || this.selectedState == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1, State, Zipcode, Country')
    //   return;
    // }
    // if (values.zipcode != '' && (values.address1 == '' || values.cityname == '' || this.selectedState == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1,Cityname, State, Country')
    //   return
    // }
    // if (this.selectedState != '' && (values.address1 == '' || values.cityname == '' || values.zipcode == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1,Cityname, Zipcode, Country')
    //   return
    // }
    // if (this.selectedCountry != '' && (values.address1 == '' || values.cityname == '' || values.zipcode == '' || this.selectedState == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1,Cityname, State, Zipcode')
    //   return
    // }

    // if( (values.dailycap == ''  || values.dailycap == 0)  && (values.weeklycap=='' || values.weeklycap== 0)){
    //   this.notifier.notify('warning', 'Please enter  daily greet cap or weekly greet cap');
    //   return
    // }
    // if(values.dailycap  && values.weeklycap ){
    //   this.notifier.notify('warning', 'Please enter  daily greet cap or weekly greet cap!');
    //   return
    // }




    var data = {
      "firstname": values.fname,
      "lastname": values.lname,
      "preferred_name": values.fname + " " + values.lname,
      "email": values.email,
      "password": values.password,
      "dob": values.dob,
      "hire_Date": values.hiredate,
      "job_code": this.selectedRole.role,
      "job_name": this.selectedRole.role,
      "job_type": this.selectedJobType,
      "role": this.selectedRole.role,
      "source": this.selectedSource,
      "mobileno": values.mobileNumber,
      "emp_id": values.empid,
      "access_level": this.selectedRole.access_level,
      "station": { "ids": this.selectedStations, "update": true },
      "language": { "ids": values.languages, "update": true },
      "languages": "English,French",
      "address1": values.address1,
      "address2": values.address2,
      "city": values.cityname,
      "state": values.state,
      "zipcode": values.zipcode,
      "country": values.country,
      "IS_TRAINEE": this.selectedTraineeType
    }
    if (this.selectedRole.access_level === AccessLevels.agent) {
      data["daily_cap"] = values.dailycap
      data["weekly_cap"] = values.weeklycap
      data["hourly_rate"] = values.hourlyrate
    }

    if (values.dob > new Date() || values.hiredate > new Date()) {
      this.notifier.notify('warning', 'Future date not allowed.')
      return;
    }

    // if (moment(values.hiredate).startOf('day').isBefore(moment(values.dob).startOf('day'))) {
    //   this.notifier.notify('warning', 'Hire date should not be less then birth date.')
    //   return;
    // }

    // if (moment(values.hiredate).startOf('day').isSame(moment(values.dob).startOf('day'))) {
    //   this.notifier.notify('warning', 'Date of birth and hire date should not be same.')
    //   return;
    // }

    this.spinner.show()
    this.employeeService.saveEmployee(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        if (this.selectedRole.access_level == AccessLevels.stationManager) {
          this.notifier.notify('success', this.selectedRole.name + ' details added successfully....')
        }
        else {
          this.notifier.notify('success', this.selectedRole.name + ' details added successfully....')
        }
       // this.initAddEmployeeForm();
        this.router.navigateByUrl("home/employees");
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
    this.router.navigateByUrl("home/employees");
  }


  onUpdateEmployee(values) {
    this.submitted = true
    this.validateEmployee()
    this.employee_form.markAllAsTouched();
    if (this.employee_form.invalid) {
      return;
    }
    if (this.selectedState == null || this.selectedState == 'undefined') {
      this.selectedState = ''
    }
    if (this.selectedCountry == null || this.selectedCountry == 'undefined') {
      this.selectedCountry = ''
    }
    // if (values.address1 != '' && (values.cityname == '' || values.zipcode == '' || this.selectedState == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Cityname, State, Zipcode, Country')
    //   return;
    // }
    // if (values.cityname != '' && (values.address1 == '' || values.zipcode == '' || this.selectedState == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1, State, Zipcode, Country')
    //   return;
    // }
    // if (values.zipcode != '' && (values.address1 == '' || values.cityname == '' || this.selectedState == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1,Cityname, State, Country')
    //   return
    // }
    // if (this.selectedState != '' && (values.address1 == '' || values.cityname == '' || values.zipcode == '' || this.selectedCountry == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1,Cityname, Zipcode, Country')
    //   return
    // }
    // if (this.selectedCountry != '' && (values.address1 == '' || values.cityname == '' || values.zipcode == '' || this.selectedState == '')) {
    //   this.notifier.notify('warning', 'Please enter  Address1,Cityname, State, Zipcode')
    //   return
    // }
    // if( (values.dailycap == ''  || values.dailycap == 0 || values.dailycap == null )  && (values.weeklycap=='' || values.weeklycap== 0 || values.weeklycap == null)){
    //   this.notifier.notify('warning', 'Please enter  daily greet cap or weekly greet cap');
    //   return
    // }
    // if(values.dailycap  && values.weeklycap ){
    //   this.notifier.notify('warning', 'Please enter  daily greet cap or weekly greet cap!');
    //   return
    // }

    var data = {
      "id": this.employeeData.id,
      "firstname": values.fname,
      "lastname": values.lname,
      "preferred_name": this.employeeData.preferred_name,
      "email": values.email,
      "password": values.password,
      "dob": moment(values.dob).format('MM/DD/YYYY HH:mm'),
      "hire_Date": moment(values.hiredate).format('MM/DD/YYYY HH:mm'),
      "job_code": this.selectedRole.role,
      "job_name": this.selectedRole.role,
      "job_type": this.selectedJobType,
      "role": this.selectedRole.role,
      "source": this.selectedSource,
      "mobileno": values.mobileNumber,
      "emp_id": values.empid,
      "access_level": this.selectedRole.access_level,
      "language": { "ids": this.selectedLanguageids, "update": true },
      "station": { "ids": this.selectedStations, "update": true },
      "address1": values.address1,
      "address2": values.address2,
      "city": values.cityname,
      "state": values.state,
      "zipcode": values.zipcode,
      "country": values.country
    }

    if (values.status != this.status[0]) {
      data["status"] = false;
      data["terminated_date"] = moment().format('MM/DD/YYYY HH:mm')
    } else {
      data["status"] = true;
      data["terminated_date"] = null
    }

    if (this.selectedRole.access_level === AccessLevels.agent) {
      data["daily_cap"] = values.dailycap
      data["weekly_cap"] = values.weeklycap
      data["hourly_rate"] = values.hourlyrate
    }

    if (values.hiredate > new Date()) {
      this.notifier.notify('warning', 'Future date not allowed!')
      return;
    }

    // if (moment(values.hiredate).startOf('day').isBefore(moment(values.dob).startOf('day'))) {
    //   this.notifier.notify('warning', 'Hire date should not be less then birth date.')
    //   return;
    // }

    // if (moment(values.hiredate).startOf('day').isSame(moment(values.dob).startOf('day'))) {
    //   this.notifier.notify('warning', 'Date of birth and hire date should not be same.')
    //   return;
    // }

    this.spinner.show()
    let resStaus
    this.employeeService.updateEmployee(data).subscribe(res => {
      this.spinner.hide()
      if (res['status']) {
        if (this.selectedRole.access_level === AccessLevels.stationManager) {
          this.notifier.notify('success', this.selectedRole.name + " details updated successfully...")
          setTimeout(() => {
           // this.location.back()
           this.router.navigateByUrl("home/employees");
          }, 1000);
        }
        else {
          this.notifier.notify('success', this.selectedRole.name + " details updated successfully...")
          setTimeout(() => {
           // this.location.back()
           this.router.navigateByUrl("home/employees");
          }, 1000);
        }
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  validateAddress(values) {

  }

  onStationChange(event) {
    this.selectedStations = (event)
  }

  onCountryChange() {
    if (this.selectedCountry != null) {
      this.spinner.show()
      this.getAllStatesByCountry()
    }
  }

  onRoleChange() {
    this.employee_form.get('role').valueChanges
      .subscribe(role => {
        this.setCapValidators(role)
      });
  }


  validation_messages = {
    'terminateddate': [
      { type: 'required', message: 'languages  is required.' }
    ],
    'status': [
      { type: 'required', message: 'languages  is required.' }
    ],
    'languages': [
      { type: 'required', message: 'languages  is required.' }
    ],
    'jobtype': [
      { type: 'required', message: 'Jobtype  is required.' }
    ],
    'stations': [
      { type: 'required', message: 'Station  is required.' }
    ],
    'hiredate': [
      { type: 'required', message: 'Hire Date is required.' }
    ],
    'role': [
      { type: 'required', message: 'Role is required.' }
    ],
    // 'dob': [
    //   { type: 'required', message: 'Date of birth is required.' }
    // ],
    'empid': [
      { type: 'required', message: 'Team Member ID is required.' },
      { type: 'maxlength', message: 'Team Member id should not be more then 15 characters long.' }
    ],
    'fname': [
      { type: 'required', message: 'First Name is required.' },
     // { type: 'minlength', message: 'First name must be 3 characters long.' },
      { type: 'pattern', message: 'Please enter alphabets only.' },
    //  { type: 'maxlength', message: 'First name should not be more then 20 characters long.' }
    ],
    'lname': [
      { type: 'required', message: 'Last Name is required.' },
    //  { type: 'minlength', message: 'Last name must be 3 characters long.' },
      { type: 'pattern', message: 'Please enter alphabets only.' },
    //  { type: 'maxlength', message: 'Last name should not be more then 20 characters long.' }

    ],
    'password': [
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be 6 characters long.' },

    ],
    'email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Email format must be similar to joe@abc.com' },
    ],
    'dailycap': [
      { type: 'required', message: 'Daily cap is required.' }
    ],
    'weeklycap': [
      { type: 'required', message: 'Weekly cap is required.' }
    ],
    'hourlyrate': [
      { type: 'required', message: 'Hourly rate is required.' },
    ],
    'mobileNumber': [
      { type: 'required', message: 'Mobile Number is required.' },
    //  { type: 'minlength', message: 'Mobile number must be minimum 10 digits long.' },
    //  { type: 'maxlength', message: 'Mobile number must not be more then 20 digits long.' },
      { type: 'pattern', message: 'Mobile number must not contain any alphabets or special characters  other than hyphen(-) and plus(+)' },
    ],
    'zipcode': [
    //  { type: 'required', message: 'Zipcode is required.' },
     // { type: 'maxlength', message: 'Zipcode should be 5 characters long.' },
      { type: 'pattern', message: 'Zip/Postal code must not contain special characters.' },
    ]

  }

  get f(): any {
    return this.employee_form.controls;
  }

  getStations() {
    if (this.authenticationService.isStationAdmin()) {
      // get login user stations
      this.employeeService.getEmployeeById(this.authenticationService.getCurrentUserId()).subscribe(res => {
        this.allStations = res['result']['stations']
      })
    } else {
      // get all stations
      this.stationService.getNonOutSourcedStations().subscribe(stations => {
        this.allStations = stations['result'];
      })
    }
  }

  // This attributes includes job_code, job_name, Languages etc
  getProjectAttributes() {
    this.projectAttrService.getProjectAttributes().subscribe(projectAttrributes => {
      this.allCountries = projectAttrributes['result']['country']
      this.allJobNames = projectAttrributes['result']['job_name']
    })
  }

  getAllStatesByCountry() {
    this.projectAttrService.getAllStatesByCountry(this.selectedCountry).subscribe(res => {
      this.spinner.hide()
      this.allStates = res['result']
    })
  }

  getAllLanguages() {
    this.projectAttrService.getAllLanguages().subscribe(res => {
      this.allLanguages = res['result']
    })
  }

  getEmployeeById(emp_id) {
    this.spinner.show();
    this.employeeService.getEmployeeById(emp_id).subscribe(employee => {
      this.employeeData = employee['result']
      this.selectedJobType = this.employeeData.job_type;
      this.selectedSource = this.employeeData.source;
      // this.selectedTraineeType = this.employeeData.IS_TRAINEE;
      this.selectedStatus = this.employeeData.status ? this.status[0] : this.status[1];
      this.selectedCountry = this.employeeData.country
      this.getAllStatesByCountry();
      this.selectedState = this.employeeData.state
      // this.selectedJobCode = this.employeeData.job_code;
      // this.selectedJobName = this.employeeData.job_name;
      this.employeeData.language.forEach(language => {
        this.selectedLanguageids.push(language.languageId);
      });

      this.employeeData.stations.forEach(station => {
        this.selectedStations.push(station.id);
      });

      if (this.employeeData.access_level == AccessLevels.stationManager) {
        this.selectedRole = this.roles[0]
      } else if (this.employeeData.role == "Sr. Concierge") {
        this.selectedRole = this.roles[2]
      } else {
        this.selectedRole = this.roles[1]
      }

      this.spinner.hide();
      this.initUpdateEmployeeForm();
    });
  }

  clearField(formFieldName) {
    this.employee_form.get(formFieldName).setValue('')
  }

  onDateChange(value) {
    if (value > new Date()) {
      this.notifier.notify('warning', 'Future date not allowed!')
    }
  }

  onBack() {
    this.location.back();
  }

  onRest() {
    this.submitted = false
    this.employee_form.reset();
    this.employee_form_controls.password.setValue("WelcomeATS")

  }

  myFunction() {
    this.hide = !this.hide;
  }

  validateEmployee() {
    if (this.employee_form_controls.empid.errors) {
      this.notifier.notify('warning', 'Please enter employee id')
      return false;
    }
    if (this.employee_form_controls.fname.errors) {
      this.notifier.notify('warning', 'Please enter first name')
      return false;
    }
    if (this.employee_form_controls.lname.errors) {
      this.notifier.notify('warning', 'Please enter last name')
      return false;
    }
    // if (this.employee_form_controls.dob.errors) {
    //   this.notifier.notify('warning', 'Please select date of birth')
    //   return false;
    // }
    if (this.employee_form_controls.email.errors) {
      this.notifier.notify('warning', 'Please enter email id')
      return false;
    }
    if (this.employee_form_controls.mobileNumber.errors) {
      this.notifier.notify('warning', 'Please enter mobile number')
      return false;
    }
    if (this.employee_form_controls.languages.errors) {
      this.notifier.notify('warning', 'Please select languages')
      return false;
    }
    if (this.employee_form_controls.jobtype.errors) {
      this.notifier.notify('warning', 'Please select job code')
      return false;
    }
    if (this.employee_form_controls.role.errors) {
      this.notifier.notify('warning', 'Please select role')
      return false;
    }
    if (this.isEditMode && this.employee_form_controls.status.errors) {
      this.notifier.notify('warning', 'Please select employee status')
      return false;
    }
    if (this.isEditMode && this.employee_form_controls.terminateddate.errors) {
      this.notifier.notify('warning', 'Please select termination date')
      return false;
    }
    if (this.employee_form_controls.hiredate.errors) {
      this.notifier.notify('warning', 'Please select hire date')
      return false;
    }
    if (this.selectedRole.access_level == AccessLevels.agent) {
      // if (this.employee_form_controls.dailycap.errors) {
      //   this.notifier.notify('warning', 'Please enter daily cap')
      //   return false;
      // }
      // if (this.employee_form_controls.weeklycap.errors) {
      //   this.notifier.notify('warning', 'Please enter weekly cap')
      //   return false;
      // }
      if (this.employee_form_controls.hourlyrate.errors) {
        this.notifier.notify('warning', 'Please enter hourly rate')
        return false;
      }
    }
    if (this.employee_form_controls.stations.errors) {
      this.notifier.notify('warning', 'Please select stations')
      return false;
    }
  }
}
